import {Incidente} from '~model/vo/tipos-incidentes-vo';

export interface EntityDocumento {
  id: string;
  arquivos: ArquivoPedido[];
  recibos?: ArquivoRecibo[];
  placa?: string;
  data?: string;
}

export interface PedidoDocumento {
  arquivos: ArquivoPedido[];
  pedido: string;
}

export interface ArquivoPedido {
  nome: string;
  formato: 'PDF' | 'IMAGEM';
  linkDownload: string;
  linkView: string;
  criacao: number;
  visita: string;
  servico: string;
  incidente?: Incidente;
  tipo?: string;
}

export interface LinkVo {
  createdIn: number;
  format: 'IMAGEM' | 'PDF';
  linkDownload: string;
  linkView: string;
  name: string;
}

export interface ArquivoRecibo {
  latitude?: number;
  longitude?: number;
  links: LinkVo[];
  timestamp: number;
  valor: number;
  mensagem?: string;
  tipoRecibo: string;
  descricaoRecibo: string;
}

export const emptyArquivoRecibo = (m?: ArquivoRecibo): ArquivoRecibo =>
  ({tipoRecibo: '', descricaoRecibo: '', valor: 0, links: [], timestamp: Date.now(), ...(m ?? {})});

export const emptyDocumento = (m?: EntityDocumento): EntityDocumento =>
  ({arquivos: [], placa: '', id: '', ...(m ?? {})});
